module.exports = __webpack_public_path__ + "static/fonts/gilroy-bold.17cb930.otf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/gilroy-bold.otf
// module id = GF+U
// module chunks = 28